import React from "react";
import Button from "../elements/Button";
import { Link } from "react-router-dom";

export default function Nav(props) {
  function scrollToSkillset() {
    if (props.refSkillset.current) {
      window.scrollTo({
        top: props.refSkillset.current.offsetTop,
        behavior: "smooth",
      });
    }
  }
  function scrollToProject() {
    if (props.refProject.current) {
      window.scrollTo({
        top: props.refProject.current.offsetTop,
        behavior: "smooth",
      });
    }
  }
  return (
    <nav className="flex py-5 px-5 lg:px-0 ">
      <div className="logo pr-2 mx-auto md:mx-0">
        <Link to="/">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="4" y="7" width="8" height="29" fill="black" />
            <rect x="16" y="4" width="8" height="27" fill="black" />
            <rect x="28" y="10" width="8" height="26" fill="black" />
            <rect
              x="1"
              y="1"
              width="38"
              height="38"
              stroke="black"
              strokeWidth="2"
            />
          </svg>
        </Link>
      </div>
      <div className="my-auto pl-5 hidden md:flex">
        <div>
          <Button
            isDense
            onClick={scrollToSkillset}
            className="hover:underline"
          >
            Skillset
          </Button>
        </div>
        <div>
          <Button isDense onClick={scrollToProject} className="hover:underline">
            Project
          </Button>
        </div>
      </div>
    </nav>
  );
}
